export interface IKeywordItem {
    word: string;
    count: number;
    synonyms?: string[];
    type?: number;
}

export enum AI_KEYWORD_RULE {
    UNOPEN = 0,
    EXACT = 1,
    AI = 2,
}
